/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_TitleInputs */



/**
* | output |
* | --- |
* | "Set Y Position" |
*
* @param {Input_Position_Y_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_title = /** @type {((inputs?: Input_Position_Y_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définir la Position Y")
	if (locale === "de") return /** @type {LocalizedString} */ ("Y-Position festlegen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta la posizione Y")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить положение по оси Y")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer la posición Y")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置 Y 轴位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Y位置を設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Y स्थिति निर्धारित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Defina a posição Y")
	return /** @type {LocalizedString} */ ("Set Y Position")
});